import { AdditionalDocumentDTO } from "../types/AdditionalDocumentDTO";
import { AdditionalDocumentCategoryDTO } from "../types/AdditionalDocumentCategoryDTO";
import { apiFetch } from "./apiFetch";
import { getApiErrorMessage, normalizeFetchError } from "./apiError";

const API_URL = process.env.REACT_APP_API_URL;

// -----------------------------
// LISTA DOKUMENTÓW
// -----------------------------
export async function getAdditionalDocuments(
  companyId: string
): Promise<AdditionalDocumentDTO[]> {
  const res = await apiFetch(
    `${API_URL}/additional-documents?companyId=${companyId}`
  );

  if (!res.ok) {
    throw new Error(
      await getApiErrorMessage(res, "Nie udało się pobrać listy dokumentów.")
    );
  }

  const data = await res.json();
  return data.value ?? data;
}

// -----------------------------
// KATEGORIE
// -----------------------------
export async function getAdditionalDocumentCategories(
  companyId: string
): Promise<AdditionalDocumentCategoryDTO[]> {
  const res = await apiFetch(
    `${API_URL}/additional-document-categories?companyId=${companyId}`);

  if (!res.ok) {
    throw new Error(
      await getApiErrorMessage(res, "Nie udało się pobrać listy kategorii dokumentów.")
    );
  }

  const data = await res.json();
  return data.value ?? data;
}

// -----------------------------
// UPLOAD
// -----------------------------
export async function uploadAdditionalDocument(
  companyId: string,
  payload: {
    fileName: string;
    description: string;
    categoryCode: string;
    accountingCategory: boolean;
    fileBase64: string;
  }
) {
  try {
    const res = await apiFetch(
      `${API_URL}/additional-documents?companyId=${companyId}`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          fileName: payload.fileName,
          Description: payload.description,
          categoryCode: payload.categoryCode,
          accountingCategory: payload.accountingCategory,
          FileBase64: payload.fileBase64,
        }),
      }
    );

    if (!res.ok) {
      throw new Error(
        await getApiErrorMessage(res, "Nie udało się dodać dokumentu.")
      );
    }

    return res.json();
  } catch (e) {
    throw normalizeFetchError(e, "Nie udało się dodać dokumentu.");
  }
}

// -----------------------------
// DELETE
// -----------------------------
export async function deleteAdditionalDocument(
  companyId: string,
  documentId: string
): Promise<void> {
  try {
    const res = await apiFetch(
      `${API_URL}/additional-documents/${documentId}?companyId=${companyId}`,
      {
        method: "DELETE",
      }
    );

    if (!res.ok) {
      throw new Error(
        await getApiErrorMessage(res, "Nie udało się usunąć dokumentu.")
      );
    }
  } catch (e) {
    throw normalizeFetchError(e, "Nie udało się usunąć dokumentu.");
  }
}
// -----------------------------
// DOCUMENT PREVIEW
// -----------------------------
export async function getAdditionalDocumentFile(
  companyId: string,
  documentId: string
): Promise<string> {
  const res = await apiFetch(
    `${API_URL}/additional-documents/${documentId}/file?companyId=${companyId}`);

  if (!res.ok) {
    throw new Error(
      await getApiErrorMessage(res, "Nie udało się pobrać pliku dokumentu.")
    );
  }

  const data = await res.json();
  return data.base64;
}




